export default __webpack_public_path__ + "static/media/easyFour.82b33a33.png";